module.exports = __webpack_public_path__ + "static/media/pandahao.259309c3.png";